import { message } from 'antd';

const useFileUploadLogic = (
  handleFileUpload,
  handleRemoveFile,
  handleUpdatePreviewUrls,
  mediaState,
  setMediaState,
  updateMediaId,
  updateSpecificMediaId,
  updateOssUrl,
  updateImageGroup,
  handleUpdateInputBoxContent,
  handleUpdateMomentBoxContent,
  inputBoxes,
  momentBoxes,
  form
) => {
  // 简化版的文件上传处理函数 - 统一使用临时素材
  const handleFileUploadWrapper = (options) => {
    console.log("处理文件上传 - 选项:", options);

    const { fieldKey, mediaType, stepType, boxId, file, onSuccess, onError, onProgress, multipleMode, contentField } = options;

    // 获取当前盒子的类型
    let boxType = null;
    if (stepType === 'MESSAGE') {
      const currentBox = inputBoxes.find(box => box.id === boxId);
      boxType = currentBox?.type;
    } else if (stepType === 'MOMENTS') {
      const currentBox = momentBoxes.find(box => box.id === boxId);
      boxType = currentBox?.type;
    }

    // 创建要传给父组件的上传参数
    const uploadOptions = {
      file,
      onSuccess: (result) => {
        console.log("文件上传成功，结果:", result);

        const mediaId = result.mediaId;
        const ossUrl = result.ossUrl;

        if (!mediaId) {
          console.error("上传成功但未返回mediaId");
          message.error("上传成功但未能获取媒体ID");
          if (onError) onError(new Error("未返回mediaId"));
          return;
        }

        const ossUrlFieldKey = `${fieldKey}_ossUrl`;
        
        // 添加到预览URLs中
        if (typeof handleUpdatePreviewUrls === 'function' && ossUrl) {
          console.log(`将上传结果添加到预览URLs: ${mediaId} -> ${ossUrl}`);
          handleUpdatePreviewUrls({ [mediaId]: ossUrl });
        }

        // 根据步骤类型更新不同的状态
        if (stepType === 'MESSAGE') {
          // 特殊处理小程序缩略图
          if (fieldKey === 'thumbMediaId' || contentField === 'thumbMediaId') {
            console.log("处理小程序缩略图上传结果:", result);
            
            handleUpdateInputBoxContent(boxId, 'thumbMediaId', mediaId);
            handleUpdateInputBoxContent(boxId, 'thumbMediaId_ossUrl', ossUrl);
            
            form.setFieldsValue({
              actionParams: {
                ...form.getFieldValue('actionParams'),
                thumbMediaId: mediaId,
                thumbMediaId_ossUrl: ossUrl
              }
            });
            
            setMediaState(prev => {
              const newState = { ...prev };
              
              newState.messageMediaIds = {
                ...prev.messageMediaIds,
                [boxId]: mediaId
              };
              
              newState.messageImageIds = {
                ...prev.messageImageIds,
                [boxId]: mediaId
              };
              
              newState.messageOssUrls = {
                ...prev.messageOssUrls || {},
                [boxId]: ossUrl
              };
              
              return newState;
            });
          }
          // 图片集类型特殊处理
          else if (boxType === 'IMAGE_GROUP' && multipleMode) {
            const currentImageGroup = mediaState.messageImageGroupIds[boxId] || { mediaIds: [], ossUrls: {} };
            
            const newImageGroup = {
              mediaIds: [...currentImageGroup.mediaIds, mediaId],
              ossUrls: {
                ...currentImageGroup.ossUrls,
                [mediaId]: ossUrl
              }
            };
            
            handleUpdateInputBoxContent(boxId, 'imageGroup', newImageGroup);
            
            setMediaState(prev => {
              return {
                ...prev,
                messageImageGroupIds: {
                  ...prev.messageImageGroupIds,
                  [boxId]: newImageGroup
                }
              };
            });
          }
          else {
            // 非图片集类型
            const actualFieldKey = mediaType === 'video' ? 'videoMediaId' : 'mediaId';

            handleUpdateInputBoxContent(boxId, actualFieldKey, mediaId);
            handleUpdateInputBoxContent(boxId, `${actualFieldKey}_ossUrl`, ossUrl);

            form.setFieldsValue({
              actionParams: {
                ...form.getFieldValue('actionParams'),
                [fieldKey]: mediaId,
                [ossUrlFieldKey]: ossUrl
              }
            });

            setMediaState(prev => {
              const newState = { ...prev };

              newState.messageMediaIds = {
                ...prev.messageMediaIds,
                [boxId]: mediaId
              };

              if (mediaType === 'image') {
                newState.messageImageIds = {
                  ...prev.messageImageIds,
                  [boxId]: mediaId
                };
              } else if (mediaType === 'video') {
                newState.messageVideoIds = {
                  ...prev.messageVideoIds,
                  [boxId]: mediaId
                };
              } else if (mediaType === 'file') {
                newState.messageFileIds = {
                  ...prev.messageFileIds,
                  [boxId]: mediaId
                };
              }

              newState.messageOssUrls = {
                ...prev.messageOssUrls || {},
                [boxId]: ossUrl
              };

              return newState;
            });
          }
        }
        else if (stepType === 'MOMENTS') {
          // 朋友圈图片集类型特殊处理
          if (boxType === 'MOMENT_IMAGE_GROUP' && multipleMode) {
            const currentImageGroup = mediaState.momentImageGroupIds[boxId] || { mediaIds: [], ossUrls: {} };
            
            const newImageGroup = {
              mediaIds: [...currentImageGroup.mediaIds, mediaId],
              ossUrls: {
                ...currentImageGroup.ossUrls,
                [mediaId]: ossUrl
              }
            };
            
            handleUpdateMomentBoxContent(boxId, 'imageGroup', newImageGroup);
            
            setMediaState(prev => {
              return {
                ...prev,
                momentImageGroupIds: {
                  ...prev.momentImageGroupIds,
                  [boxId]: newImageGroup
                }
              };
            });
          } else {
            // 非图片集类型
            handleUpdateMomentBoxContent(boxId, 'mediaId', mediaId);
            handleUpdateMomentBoxContent(boxId, 'mediaId_ossUrl', ossUrl);

            form.setFieldsValue({
              actionParams: {
                ...form.getFieldValue('actionParams'),
                [fieldKey]: mediaId,
                [ossUrlFieldKey]: ossUrl
              }
            });

            setMediaState(prev => {
              const newState = { ...prev };

              newState.momentMediaIds = {
                ...prev.momentMediaIds,
                [boxId]: mediaId
              };

              if (mediaType === 'image') {
                newState.momentImageIds = {
                  ...prev.momentImageIds,
                  [boxId]: mediaId
                };
              } else if (mediaType === 'video') {
                newState.momentVideoIds = {
                  ...prev.momentVideoIds,
                  [boxId]: mediaId
                };
              } else if (mediaType === 'file') {
                newState.messageFileIds = {
                  ...prev.messageFileIds,
                  [boxId]: mediaId
                };
              }

              newState.momentOssUrls = {
                ...prev.momentOssUrls || {},
                [boxId]: ossUrl
              };

              return newState;
            });
          }
        }

        if (onSuccess) onSuccess(result);
      },
      onError: (error) => {
        console.error("文件上传失败:", error);
        if (onError) onError(error);
      },
      onProgress: onProgress,
      fieldKey,
      mediaType,
      useTempMedia: true,
      stepType,
      contentField
    };

    return handleFileUpload(uploadOptions);
  };

  // 文件删除处理函数
  const handleRemoveFileWrapper = (fieldKey, boxId, stepType, mediaId) => {
    console.log(`删除文件 - 字段: ${fieldKey}, 盒子ID: ${boxId}, 步骤类型: ${stepType}, 媒体ID: ${mediaId}`);

    const ossUrlFieldKey = `${fieldKey}_ossUrl`;

    handleRemoveFile(fieldKey);

    if (stepType === 'MESSAGE') {
      const currentBox = inputBoxes.find(box => box.id === boxId);
      const boxType = currentBox?.type;

      // 特殊处理小程序缩略图
      if (fieldKey === 'thumbMediaId') {
        console.log('删除小程序缩略图');
        
        handleUpdateInputBoxContent(boxId, 'thumbMediaId', '');
        handleUpdateInputBoxContent(boxId, 'thumbMediaId_ossUrl', '');
        
        form.setFieldsValue({
          actionParams: {
            ...form.getFieldValue('actionParams'),
            thumbMediaId: undefined,
            thumbMediaId_ossUrl: undefined
          }
        });
        
        setMediaState(prev => {
          const newState = { ...prev };
          
          if (newState.messageMediaIds) {
            const newMessageMediaIds = { ...newState.messageMediaIds };
            delete newMessageMediaIds[boxId];
            newState.messageMediaIds = newMessageMediaIds;
          }
          
          if (newState.messageImageIds) {
            const newMessageImageIds = { ...newState.messageImageIds };
            delete newMessageImageIds[boxId];
            newState.messageImageIds = newMessageImageIds;
          }
          
          const newOssUrls = { ...newState.messageOssUrls || {} };
          delete newOssUrls[boxId];
          newState.messageOssUrls = newOssUrls;
          
          return newState;
        });
      }
      // 图片集类型特殊处理
      else if (boxType === 'IMAGE_GROUP' && mediaId) {
        const currentImageGroup = mediaState.messageImageGroupIds[boxId] || { mediaIds: [], ossUrls: {} };
        
        const newImageGroup = {
          mediaIds: currentImageGroup.mediaIds.filter(id => id !== mediaId),
          ossUrls: { ...currentImageGroup.ossUrls }
        };
        
        delete newImageGroup.ossUrls[mediaId];
        
        handleUpdateInputBoxContent(boxId, 'imageGroup', newImageGroup);
        
        setMediaState(prev => {
          return {
            ...prev,
            messageImageGroupIds: {
              ...prev.messageImageGroupIds,
              [boxId]: newImageGroup
            }
          };
        });
      } else {
        // 非图片集类型
        handleUpdateInputBoxContent(boxId, fieldKey === 'videoMediaId' ? 'videoMediaId' : 'mediaId', '');
        handleUpdateInputBoxContent(boxId, fieldKey === 'videoMediaId' ? 'videoMediaId_ossUrl' : 'mediaId_ossUrl', '');

        form.setFieldsValue({
          actionParams: {
            ...form.getFieldValue('actionParams'),
            [fieldKey]: undefined,
            [ossUrlFieldKey]: undefined
          }
        });

        setMediaState(prev => {
          const newState = { ...prev };

          if (newState.messageMediaIds) {
            const newMessageMediaIds = { ...newState.messageMediaIds };
            delete newMessageMediaIds[boxId];
            newState.messageMediaIds = newMessageMediaIds;
          }

          if ((fieldKey === 'mediaId' && boxType === 'IMAGE') && newState.messageImageIds) {
            const newMessageImageIds = { ...newState.messageImageIds };
            delete newMessageImageIds[boxId];
            newState.messageImageIds = newMessageImageIds;
          }
          else if ((fieldKey === 'videoMediaId' || (fieldKey === 'mediaId' && boxType === 'VIDEO')) && newState.messageVideoIds) {
            const newMessageVideoIds = { ...newState.messageVideoIds };
            delete newMessageVideoIds[boxId];
            newState.messageVideoIds = newMessageVideoIds;
          }
          else if ((fieldKey === 'fileMediaId' || (fieldKey === 'mediaId' && boxType === 'FILE')) && newState.messageFileIds) {
            const newMessageFileIds = { ...newState.messageFileIds };
            delete newMessageFileIds[boxId];
            newState.messageFileIds = newMessageFileIds;
          }

          const newOssUrls = { ...newState.messageOssUrls || {} };
          delete newOssUrls[boxId];
          newState.messageOssUrls = newOssUrls;

          return newState;
        });
      }
    }
    else if (stepType === 'MOMENTS') {
      const currentBox = momentBoxes.find(box => box.id === boxId);
      const boxType = currentBox?.type;

      // 朋友圈图片集类型特殊处理
      if (boxType === 'MOMENT_IMAGE_GROUP' && mediaId) {
        const currentImageGroup = mediaState.momentImageGroupIds[boxId] || { mediaIds: [], ossUrls: {} };
        
        const newImageGroup = {
          mediaIds: currentImageGroup.mediaIds.filter(id => id !== mediaId),
          ossUrls: { ...currentImageGroup.ossUrls }
        };
        
        delete newImageGroup.ossUrls[mediaId];
        
        handleUpdateMomentBoxContent(boxId, 'imageGroup', newImageGroup);
        
        setMediaState(prev => {
          return {
            ...prev,
            momentImageGroupIds: {
              ...prev.momentImageGroupIds,
              [boxId]: newImageGroup
            }
          };
        });
      } else {
        // 清除朋友圈输入框中的mediaId和ossUrl
        handleUpdateMomentBoxContent(boxId, 'mediaId', '');
        handleUpdateMomentBoxContent(boxId, 'mediaId_ossUrl', '');

        setMediaState(prev => {
          const newState = { ...prev };

          if (newState.momentMediaIds) {
            const newMomentMediaIds = { ...newState.momentMediaIds };
            delete newMomentMediaIds[boxId];
            newState.momentMediaIds = newMomentMediaIds;
          }

          if (boxType === 'MOMENT_IMAGE' && newState.momentImageIds) {
            const newMomentImageIds = { ...newState.momentImageIds };
            delete newMomentImageIds[boxId];
            newState.momentImageIds = newMomentImageIds;
          } else if (boxType === 'MOMENT_VIDEO' && newState.momentVideoIds) {
            const newMomentVideoIds = { ...newState.momentVideoIds };
            delete newMomentVideoIds[boxId];
            newState.momentVideoIds = newMomentVideoIds;
          }

          const newOssUrls = { ...newState.momentOssUrls || {} };
          delete newOssUrls[boxId];
          newState.momentOssUrls = newOssUrls;

          return newState;
        });
      }
    }
  };

  return {
    handleFileUploadWrapper,
    handleRemoveFileWrapper
  };
};

export default useFileUploadLogic; 